import { render, staticRenderFns } from "./Carousal.vue?vue&type=template&id=0289f2f9&"
import script from "./Carousal.vue?vue&type=script&lang=js&"
export * from "./Carousal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports